import AgendaViewBase from '../AgendaViewBase/AgendaViewBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EventDutyFinder.html?raw';
import FullscreenDialog from '../../moreCore/UI/FullscreenDialog/FullscreenDialog';
import "../../moreCore/UI/FullscreenDialog/FullscreenDialog";
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import "../../moreCore/UI/GenericDialog/GenericDialog";

class EventDutyFinder extends compose(AgendaViewBase<any>) {
    templateString: any = template;


    fullScreenDlg: MdsLax<InstanceType<typeof FullscreenDialog>>;
    genericDialog: MdsLax<InstanceType<typeof GenericDialog>>;

    // das alles bekommen wir dann von der API evtl oder whatever -- parameter die sich nicht ändern

    eventTable_formatterFunction(cell: StaticTable.StaticTableCell<FileFinder.FileDescriptor>) {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        switch (colName) {
            case "date":
                let dateFrom = entity["date_forerun"];
                let dateTo = entity["date_trailer"];

                if (dateFrom.slice(5, 7) == dateTo.slice(5, 7) && dateFrom.slice(8, 10) == dateTo.slice(8, 10)) {
                    var sYear: string = dateFrom.slice(0, 4);
                    var sMonth: string = dateFrom.slice(5, 7);
                    var sDay: string = dateFrom.slice(8, 10);
                    var sHourFrom: string = dateFrom.slice(11, 13);
                    var sHourTo: string = dateTo.slice(11, 13);
                    var sMinuteFrom: string = dateFrom.slice(14, 16);
                    var sMinuteTo: string = dateTo.slice(14, 16);
                    node.innerHTML = `${sDay}.${sMonth}.${sYear}, ${sHourFrom}:${sMinuteFrom} - ${sHourTo}:${sMinuteTo}`
                } else {
                    node.innerHTML = this.dateToLocalISOString(dateFrom) + " - " + this.dateToLocalISOString(dateTo)
                }

                break;
            default:
                node.innerHTML = value;
        }
    }


    // je nach dem ob sich die Widgets ersetzen sollen oder synchronisieren usw.
    
    tableRowButton_click_edit(rowData): void {
        
        //this.createAttendanceListEditor(rowData.rowGroup);
    }

    createAttendanceListEditor: any = function (cellData): void {
       
    };
    

    initAgendaView() {

        this.setupAgendaView("EventDutyFinder/GetFilterpanelOptions",
            "EventDutyFinder/GetEventList",
            lang.hitch(this, this.createAttendanceListEditor),
            this.eventTable_formatterFunction);
    }

    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.initAgendaView();
        this.setTitles("Eventduties", "Eventduties");
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EventDutyFinder);